// Template types that work with both Prisma and GraphQL data
// These define the minimum required shape - any object matching this interface will work
export var TemplateVariable;
(function (TemplateVariable) {
    TemplateVariable["FacilityNames"] = "facilityNames";
    TemplateVariable["CompanyName"] = "companyName";
})(TemplateVariable || (TemplateVariable = {}));
export var TemplateName;
(function (TemplateName) {
    /** @deprecated - use TierIIEmail instead*/
    TemplateName["TierIIEmailSingle"] = "tierIIEmailSingle";
    /** @deprecated - use TierIIEmail instead */
    TemplateName["TierIIEmailBulk"] = "tierIIEmailBulk";
    TemplateName["TierIIEmail"] = "tierIIEmail";
    TemplateName["OhioSerc"] = "ohioSerc";
    TemplateName["MailRoomFlexible"] = "mailRoomFlexible";
    TemplateName["T2SRemediationEmail"] = "t2sRemediationEmail";
    TemplateName["Default"] = "default";
})(TemplateName || (TemplateName = {}));
//# sourceMappingURL=types.js.map